import { useQuery } from 'react-query'
import { SolutionType } from '@dc-shared-web/hooks/api/solutionType'
import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'
import {
  fetchSolutionTypes,
  GetSolutionTypeQueryParams,
} from '@dc-shared-web/hooks/api/solutionType/fetchSolutionTypes'

export const useGetSolutionTypes = (params?: GetSolutionTypeQueryParams) => {
  const apiClient = useAxiosContext()

  return useQuery<SolutionType[], Error>(['solution-types', params?.team], () =>
    fetchSolutionTypes(apiClient, params)
  )
}
